/*!

=========================================================
* Now UI Dashboard React - v1.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard.js";
import TrainingLoad from "views/TrainingLoad.js";
import Notifications from "views/Notifications.js";
import Analytics from "views/Analytics.js";
import TableList from "views/TableList.js";
import Maps from "views/Maps.js";
import Upgrade from "views/Upgrade.js";
import UserPage from "views/UserPage.js";
import RunningProgram from 'views/RunningProgram.js'
import TrainingZones from 'views/TrainingZones.js'
import ImportExport from 'views/ImportExport'
import Input from 'views/Input'
import About from 'views/About'
import Planner from 'views/Planner'
import Tools from 'views/Tools'


import logo from "./assets/img/logo3.png";
import DashLogo from "./assets/img/dashboard.svg";
import TrainingLoadLogo from "./assets/img/graph2.svg";
import AnalyticsLogo from './assets/img/graph.svg'
import History from './assets/img/history.svg'
import Calendar from './assets/img/calendar.svg'
import Ecg from './assets/img/electrocardiogram.svg'
import InputPhoto from './assets/img/input.svg'
import DownloadPhoto from './assets/img/download.svg'
import Question from './assets/img/question.svg'
import user from './assets/img/user.svg'
import Watch from './assets/img/trend.svg'
import StopWatch from './assets/img/stopwatch.png'




var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: DashLogo,
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/input",
    name: "Input",
    icon: InputPhoto,
    component: Input,
    layout: "/admin",
  },
  {
    path: "/trainingLoad",
    name: "Training Load",
    icon: TrainingLoadLogo,
    component: TrainingLoad,
    layout: "/admin",
  },
  {
    path: "/analytics",
    name: "Analytics",
    icon: AnalyticsLogo,
    component: Analytics,
    layout: "/admin",
  },
  {
    path: "/running-program",
    name: "Running Program",
    icon: Watch,
    component: RunningProgram,
    layout: "/admin",
  },
  {
    path: "/planner",
    name: "Planner",
    icon: Calendar,
    component: Planner,
    layout: "/admin",
  },
  {
    path: "/training-history",
    name: "Training History",
    icon: History,
    component: TableList,
    layout: "/admin",
  },
  
  {
    path: "/trainingzones",
    name: "Training Zones",
    icon: Ecg,
    component: TrainingZones,
    layout: "/admin",
  },
  {
    path: "/tools",
    name: "Tools",
    icon: StopWatch,
    component: Tools,
    layout: "/admin",
  },
  {
    path: "/user-page",
    name: "User Profile",
    icon: user,
    component: UserPage,
    layout: "/admin",
  },
  {
    path: "/about",
    name: "About",
    icon: Question,
    component: About,
    layout: "/admin",
  },
  {
    path: "/:import_export",
    name: "Import/Export",
    icon: DownloadPhoto,
    component: ImportExport,
    layout: "/admin",
  },
  
];
export default dashRoutes;
